(function ($) {
  function findDuplicateIds() {
    var ids = {};
    var all = $('[id]');
    $.each(all, function () {
      var id = $(this).attr('id');

      if (id) {
        if (ids[id]) {
          alert('Duplicate id: #' + id);
        } else {
          ids[id] = 1;
        }
      }
    });
  }

  function afterAjaxChecks() {
    $(document).on('ajaxComplete', function () {
      findDuplicateIds();
    });
  }

  $(function () {
    findDuplicateIds();
    afterAjaxChecks();
  });
})(jQuery);